import { CurrencyCode } from '@buggy/shared'
import { z } from 'zod'

export const priceRangeSchema = z.object({
  min_price: z.number(),
  max_price: z.number().nullable(),
  currency: z.nativeEnum(CurrencyCode),
})
export type PriceRange = z.infer<typeof priceRangeSchema>
